/**
 * Util for finding out if we should redirect on logout or not.
 */
const shouldRedirectAfterLogout = () => {
	// DAR-435
	// Lazy way to check if the player is in a casino game. Using isInGame state is not enough.
	return window.location.pathname.includes('/game/');
};

export default shouldRedirectAfterLogout;
